<script>
  import options from './GeneralSearch.options'
  export default options
</script>

<template>
  <!-- hide entire component if hideNoResults is set and there are no results  -->
  <template v-if="hideNoResults && !resultCount"></template>

  <template v-else>
    <h1 v-if="existLabel('searchTitle')" class="kb-general-search__results kb-general-search__results--title" aria-live="polite">
      {{ getLabel('searchTitle') }}
      <span v-if="resultCount && displayProperties.showSearchTitleCount" class="kb-general-search__results--number">
        {{ searchTitleCountLabel }}
      </span>
    </h1>

    <section class="kb-general-search" :class="gridTypeList()" >
      <template v-if="resultCount">
        <template v-if="!displayProperties.hideTotalCount || displayProperties.sortOptions || displayProperties.showCtaButton">
          <div class="kb-general-search__meta-top-container" aria-live="polite">
            <div v-if="!displayProperties.hideTotalCount" 
              class="kb-general-search__results__result-number" 
              :class="{'kb-general-search__results__result-number--fixed-header': displayProperties.listType === 'fixed-header' }">
                {{ totalCountLabel }}
            </div>
            <div v-if="displayProperties.showCtaButton && getLabel('ctaLink')" class="kb-general-search__cta">
              <a class="kb-button kb-button--full-color-spot" :href="getLabel('ctaLink')">{{ getLabel('ctaLinkText') }}</a>
            </div>
            <div class="kb-general-search__results__listHeader">{{getLabel('listHeader')}}</div>
            <SortDropdown v-if="displayProperties.sortOptions" :config="displayProperties.sortOptions" :guid="guid" :sortingHandler="sortingHandler" />
          </div>
        </template>
      </template>

      <template v-if="tags.length && !displayProperties.hideTags">
        <ul aria-label="Valgte filtre" class=" kb-general-search__tags kb-general-search__active-facets">
          <template v-for="(tag, index) in tags" :key="index">
            <template v-if="tag.facetName">
              <li>
                <button :aria-label="`Fjern filtrering på ${tag.facetName}`" class="kb-general-search__tag" v-on:click="clearFilterOnTag(tag)">
                {{tag.facetName}}
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_489_1707)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.29293 3.89701L0.146484 7.04346L0.853591 7.75056L4.00004 4.60412L7.14648 7.75056L7.85359 7.04346L4.70714 3.89701L7.85359 0.750564L7.14648 0.043457L4.00004 3.1899L0.853591 0.043457L0.146484 0.750564L3.29293 3.89701Z" fill="#3C3C3C"></path>
                  </g>
                  <defs>
                  <clipPath id="clip0_489_1707">
                    <rect width="8" height="8" fill="white"></rect>
                  </clipPath>
                  </defs>
                </svg>
                </button>
              </li>
            </template>
          </template>
        </ul>
      </template>

      <template v-if="!resultCount && !showSpinner && !hideNoResults">
        <template v-if="displayProperties.showCtaButton">
          <div class="kb-general-search__meta-top-container" aria-live="polite">
            <div v-if="displayProperties.showCtaButton && getLabel('ctaLink')" class="kb-general-search__cta">
              <a class="kb-button kb-button--full-color-spot" :href="getLabel('ctaLink')">{{ getLabel('ctaLinkText') }}</a>
            </div>
          </div>
        </template>
        <div class="kb-general-search__no-results">
          <h2>{{getLabel('noResultTitle')}}</h2>
          <p class="kb-general-search__no-results__summary">{{getLabel('noResultDesc')}}</p>
          <a :href="getLabel('noResultButtonHref')" class="kb-button kb-button--full-color-spot">{{getLabel('noResultButtonText')}}</a>
        </div>
      </template>

      <template v-else>

        <template v-if="displayProperties.listType === 'fixed-header'">
          <div class="kb-general-search__group" v-for="(group,groupKey) in results" :key="groupKey">
            <h2 class="kb-general-search__group__letter" :id="`month-${group.key}`">
              {{group.month}}
              <span v-if="group.year" class="kb-general-search__group__letter year">{{ group.year }}</span>
            </h2>
            <ul class="kb-general-search__results" :class="displayModifications">
              <template v-for="(result,index) in group.entries" :key="index">
                <template v-if="result.isSpotCard">
                  <li>
                    <component :is="spotCardComponent" :spotCardData="result" />
                  </li>
                </template>
                <template v-else>
                  <li>
                    <component
                      :is="displayProperties.card"
                      :result="result"
                      :displayProperties="displayProperties"
                      :imageRatio="getResultImageRatio(result)"
                      :imageType="getResultImageType(result)"
                    />
                  </li>
                </template>
              </template>
            </ul>
          </div>
        </template>

        <template v-else>
          <ul class="kb-general-search__results" :class="displayModifications">
            <template v-for="(result, index) in results" :key="index">

              <template v-if="result.isSpotCard">
                <component :is="spotCardComponent" :spotCardData="result" />
              </template>
              <template v-else>
                <component 
                  :is="displayProperties.card" 
                  :result="result" 
                  :displayProperties="displayProperties" 
                  :imageRatio="getResultImageRatio(result)"
                  :imageType="getResultImageType(result)"
                />
              </template>

            </template>
          </ul>
        </template>

      </template>

      <div class="kb-general-search__more-results">
        <span v-if="resultCount" class="kb-general-search__more-results__text">Viser {{ resultCount }} ud af {{ totalCount }} {{getLabel('resultTypeTitle')}} </span>
        <template v-if="canShowMore">
          <button @click="getMoreResults" class="kb-button kb-button--full-color">
            {{getLabel('showMoreButtonText')}}
          </button>
        </template>
      </div>

      <div v-if="showSpinner" class="kb-spinner-overlay">
        <div class="kb-spinner-overlay__spinner">
        </div>
      </div>

    </section>
  </template>
</template>
